import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "../scss/IA.scss";
import picture from "../images/Group 10753.svg";
import IACover from "./IACover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
function IApreviewModal({ isOpen, toggle, analysis }) {
  return (
    <Modal isOpen={isOpen} style={{ minWidth: "900px", position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: "-10px",
          right: "-10px",
          width: "30px",
          height: "30px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "30px",
          backgroundColor: "black",
        }}
        onClick={toggle}
      >
        <FontAwesomeIcon icon={faTimes} color="#ffffff" size="1x" />
      </div>

      <IACover analysis={analysis} header={false} />
    </Modal>
  );
}

export default IApreviewModal;
